

// src/components/ProtectedRoute.tsx
// import { useEffect, useState } from "react";
// import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
// import { authService } from "../src/api/services/authService";
// import {
//   getTargetOnboardingPath,
//   ONBOARDING_STEPS,
// } from "../src/api/utils/onboardingNavigation";
// import { tokenService } from "../src/api/utils/tokenService";

// const ProtectedRoute = () => {
//   const token = tokenService.getAccessToken();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [isVerifying, setIsVerifying] = useState(true);

//   useEffect(() => {
//     const verifyFlow = async () => {
//       if (!token) {
//         setIsVerifying(false);
//         return;
//       }

//       try {
//         const res = await authService.getOnboardingStatus();
//         const status = res.data;
//         const partner = JSON.parse(localStorage.getItem("partner") || "{}");

//         const targetPath = getTargetOnboardingPath(
//   status,
//   partner,
//   location.pathname   // ✅ IMPORTANT
// );

//         const path = location.pathname.replace(/\/+$/, "");
//         const isFromDashboard = location.state?.fromDashboard;

//         // 🔥 GLOBAL GUARD (MOST IMPORTANT FIX)
//         if (path.startsWith("/provider-team") && !isFromDashboard) {
//           setIsVerifying(false);
//           navigate("/profileStatus", { replace: true });
//           return;
//         }

//         // =========================
//         // 1. FINAL STATE
//         // =========================
//         if (status.onboardingStatus === "SUBMITTED") {
//           const blockedPages = [
//             "/service-area",
//             "/business-information",
//             "/menu-builder",
//           ];

//           if (blockedPages.some((p) => path.startsWith(p))) {
//             navigate("/Dashboard", { replace: true });
//             return;
//           }

//           const dashboardAllowedPages = [
//             "/Dashboard",
//             "/Dashboard/Bookings",
//             "/Dashboard/Providers",
//             "/profileStatus",
//           ];

//           const isProviderTeamAllowed =
//             path.startsWith("/provider-team") && isFromDashboard;

//           const isOnDashboard =
//             dashboardAllowedPages.some(
//               (p) => path === p || path.startsWith(p + "/")
//             ) || isProviderTeamAllowed;

//           if (!isOnDashboard) {
//             navigate("/Dashboard", { replace: true });
//             return;
//           }

//           setIsVerifying(false);
//           return;
//         }

//         // =========================
//         // 2. HUB STATE
//         // =========================
//         if (targetPath === "/profileStatus") {
//           const isBillingPath = path.startsWith("/billing/");

//           const hubAllowedPages = [
//             "/profileStatus",
//             "/menu-builder",
//             "/business-information",
//             "/service-area",
//             "/billing/subscription",
//             "/Dashboard",
//             "/Dashboard/Bookings",
//             "/Dashboard/Providers",
//           ];

//           const isAllowedHubPath = hubAllowedPages.some(
//             (p) => path === p || path.startsWith(p + "/")
//           );

//           if (isAllowedHubPath || isBillingPath) {
//             setIsVerifying(false);
//             return;
//           } else {
//             navigate("/profileStatus", { replace: true });
//             return;
//           }
//         }

//         // =========================
//         // 3. LINEAR FLOW
//         // =========================
//         const currentIndex = ONBOARDING_STEPS.indexOf(location.pathname);
//         const requiredIndex = ONBOARDING_STEPS.indexOf(targetPath);

//         const isAtServiceArea = targetPath === "/service-area";
//         const isAtBilling = targetPath.includes("/billing");

//         let isAllowed = true;

//         if (isAtServiceArea) {
//           if (
//             currentIndex < requiredIndex - 1 ||
//             currentIndex > requiredIndex
//           ) {
//             isAllowed = false;
//           }
//         } else if (isAtBilling) {
//           const isAnyBillingPage =
//             location.pathname.startsWith("/billing/");

//           if (isAnyBillingPage) {
//             isAllowed = true;
//           } else if (currentIndex > requiredIndex) {
//             isAllowed = false;
//           }
//         } else {
//           if (
//             currentIndex > requiredIndex ||
//             (currentIndex !== -1 && currentIndex < requiredIndex - 1)
//           ) {
//             isAllowed = false;
//           }
//         }

//         if (!isAllowed || currentIndex === -1) {
//           if (location.pathname !== targetPath) {
//             navigate(targetPath, { replace: true });
//             return;
//           }
//         }
//       } catch (error) {
//         console.error("Session verification failed", error);
//       } finally {
//         setIsVerifying(false);
//       }
//     };

//     verifyFlow();
//   }, [token, location.pathname, location.state, navigate]);

//   if (!token) return <Navigate to="/" replace />;
//   if (isVerifying) return null;

//   return <Outlet />;
// };

// export default ProtectedRoute;




// src/components/ProtectedRoute.tsx
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../src/api/services/authService';
import { getTargetOnboardingPath, ONBOARDING_STEPS } from '../src/api/utils/onboardingNavigation';
import { tokenService } from '../src/api/utils/tokenService';
import { createOnboardingRepository } from "../src/features/onboarding/data/repositories/createOnboardingRepository";




const ProtectedRoute = () => {
  const token = tokenService.getAccessToken();
  const location = useLocation();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);

  

  useEffect(() => {
    const verifyFlow = async () => {
      if (!token) {
        setIsVerifying(false);
        return;
      }

      try {

        const res = await authService.getOnboardingStatus();
        const status = res.data;
        const partner = JSON.parse(localStorage.getItem("partner") || "{}");
     const onboardingRepo =
  createOnboardingRepository();

const onboardingData =
  await onboardingRepo.getPartnerOnboarding();
  console.log(
  "FIRST ACCOUNT TYPE",
  JSON.stringify(
    onboardingData.accountTypes?.[0],
    null,
    2
  )
);

  console.log("FULL ONBOARDING DATA", onboardingData);
console.log("ACCOUNT TYPES", onboardingData.accountTypes);
console.log("FIRST ACCOUNT TYPE", onboardingData.accountTypes?.[0]);

console.log("ONBOARDING DATA", onboardingData);
console.log(
  "ACCOUNT TYPES",
  onboardingData.accountTypes
);


const accountType =
  (onboardingData.accountTypes?.[0] as any)
    ?.details?.code;

if (accountType) {
  localStorage.setItem(
    "accountType",
    accountType
  );
}
console.log("ACCOUNT TYPE", accountType);
console.log(
  "ACCOUNT TYPE ID",
  accountType
);
        console.log("partner", partner);
        console.log({
  accountTypeFromStorage:
    localStorage.getItem("accountType"),
  partnerAccountType:
    partner?.accountType,
});

        // Use the utility to find where the user belongs
   const targetPath = getTargetOnboardingPath(
  status,
  {
    ...partner,
    accountType,
  },
  location.pathname
);


        // 1. FINAL STATE: If fully submitted, bypass all guards
        if (status.onboardingStatus === "SUBMITTED") {
          const dashboardAllowedPages = [
            "/Dashboard",
            "/Dashboard/Bookings",
            "/Dashboard/Providers",
            "/service-area",
            "/profileStatus",
            "/billing/confirm",
            "/billing/success",
            "/billing/subscription",
            "/provider-team",
            "/menu-builder",
            "/stripe-flow",


            "/individual-information",
            "/individual-provider-verification",
            "/clinical-live-bookings",
            "/non-clinical-bookings",
            "/clinical-checklist",
            "/provider-review",
            "/vitals-recorded",
            "/iv-materials-logged",
          ];
          const path = location.pathname.replace(/\/+$/, "");

          const isOnDashboard = dashboardAllowedPages.some(
            (p) => path === p || path.startsWith(p + "/")
          );

          if (!isOnDashboard) {
            navigate("/Dashboard", { replace: true });
            return;
          }

          setIsVerifying(false);
          return;
        }

        // 2. HUB STATE: Reached profileStatus
        if (targetPath === "/profileStatus") {
          const hubAllowedPages = [
            "/profileStatus",
            "/provider-team",
            "/menu-builder",
            "/stripe-flow",
            "/business-information",
            "/individual-information",
            "/service-area",

            "/billing/confirm",
            "/billing/success",
            "/billing/subscription",
            "/Dashboard",
            "/Dashboard/Bookings",
            "/Dashboard/Providers",


            "/clinical-live-bookings",
            "/non-clinical-bookings",
            "/clinical-checklist",
            "/provider-review",
            "/vitals-recorded",
            "/iv-materials-logged",

          ];

          const path = location.pathname.replace(/\/+$/, "");
          const isBillingPath = path.startsWith("/billing/");

          const isAllowedHubPath = hubAllowedPages.some(
            (p) => path === p || path.startsWith(p + "/")
          );

          if (isAllowedHubPath || isBillingPath) {
            setIsVerifying(false);
            return;
          } else {
            navigate("/profileStatus", { replace: true });
            return;
          }
        }

        // 3. LINEAR PHASE: Permission Zones
        const currentIndex = ONBOARDING_STEPS.indexOf(location.pathname);
        const requiredIndex = ONBOARDING_STEPS.indexOf(targetPath);

        const isAtServiceArea = targetPath === "/service-area";
        const isAtBilling = targetPath.includes("/billing");

        let isAllowed = true;

        if (isAtServiceArea) {
          const businessIndex =
            ONBOARDING_STEPS.indexOf(
              "/business-information"
            );

          const individualIndex =
            ONBOARDING_STEPS.indexOf(
              "/individual-information"
            );

          if (
            currentIndex !== businessIndex &&
            currentIndex !== individualIndex &&
            currentIndex !== requiredIndex
          ) {
            isAllowed = false;
          }
        }
        else if (isAtBilling) {
          const isAnyBillingPage =
            location.pathname.startsWith("/billing/");

          if (isAnyBillingPage) {
            isAllowed = true;
          } else if (currentIndex > requiredIndex) {
            isAllowed = false;
          }
        }
        else {
          // ZONE: Early Steps - Strictly 1 step back or current
          if (currentIndex > requiredIndex || (currentIndex !== -1 && currentIndex < requiredIndex - 1)) {
            isAllowed = false;
          }
        }

        // Final enforcement
        if (!isAllowed || currentIndex === -1) {
          if (location.pathname !== targetPath) {
            navigate(targetPath, { replace: true });
            return;
          }
        }

      } catch (error) {
        console.error("Session verification failed", error);
      } finally {
        setIsVerifying(false);
      }
    };

    verifyFlow();
  }, [token, location.pathname, location.state, navigate]);

  if (!token) return <Navigate to="/" replace />;
  if (isVerifying) return null;

  return <Outlet />;
};

export default ProtectedRoute;